<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

defineProps({
  submitLabel: { type: String, required: true },
  cancelLabel: { type: String, required: true },
  hint: { type: String, default: '' },
  isValid: { type: Boolean, default: false },
  isLoading: { type: Boolean, default: false },
});

const emit = defineEmits(['cancel']);
</script>

<template>
  <div
    class="sticky bottom-0 z-20 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-n-weak bg-n-solid-2 px-4 py-3 shadow-sm"
  >
    <p
      v-if="hint"
      role="status"
      class="mb-0 flex min-w-0 items-center gap-2 text-sm"
      :class="isValid ? 'text-n-slate-11' : 'text-n-amber-11'"
    >
      <Icon
        :icon="
          isValid
            ? 'i-hugeicons-checkmark-circle-02'
            : 'i-hugeicons-alert-circle'
        "
        class="size-4 shrink-0"
      />
      <span class="min-w-0">{{ hint }}</span>
    </p>
    <div class="flex flex-wrap items-center gap-2 ltr:ml-auto rtl:mr-auto">
      <Button
        type="button"
        color="slate"
        variant="faded"
        :label="cancelLabel"
        data-test-id="policy-form-cancel"
        @click="emit('cancel')"
      />
      <Button
        type="submit"
        :label="submitLabel"
        :disabled="!isValid || isLoading"
        :is-loading="isLoading"
        data-test-id="policy-form-submit"
      />
    </div>
  </div>
</template>
